// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9895f944","238":"c4da4498","239":"574bd414","455":"0e8abe67","762":"d609e0ab"}[chunkId] + ".chunk.js";
};